import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';

import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';

const PaymentMethodsPage = lazyWithRetry(() =>
  import('../pages/PaymentMethodsPage.tsx'),
);

const CashboxesPage = lazyWithRetry(() =>
  import('../pages/CashboxesPage.tsx'),
);

const paymentMethodsNode = {
  component: PaymentMethodsPage,
} satisfies ComponentPage;

const cashboxesNode = {
  component: CashboxesPage,
} satisfies ComponentPage;

const paymentsRoutes: ComponentOrMapping = {
  erp: {
    payments: {
      methods: paymentMethodsNode,
      cashboxes: cashboxesNode,
    },
  },
};

export default paymentsRoutes;
